import {DEPOSIT_CONTRIBUTION_SHARE_RATE, DEPOSIT_FEE_SPREAD_RATE} from "../../../../constants";

const WEEKS_DEPOSIT = 5;
const MONTHS_PER_YEAR = 12;
const WEEKS_PER_YEAR = 52;

function formatPounds(amount: number): string {
  return `£${Math.round(amount).toLocaleString("en-GB")}`;
}

function formatPercent(value: number): string {
  return `${Math.round(value * 100)}%`;
}

function formatRentInput(input: HTMLInputElement, preserveCaret: boolean): number {
  const rawValue = input.value;
  const digitsOnly = rawValue.replace(/[^\d]/g, "");
  const rentPerMonth = Number.parseInt(digitsOnly, 10) || 0;
  const formattedValue = digitsOnly ? rentPerMonth.toLocaleString("en-GB") : "";

  if (preserveCaret && document.activeElement === input) {
    const cursorPosition = input.selectionStart ?? rawValue.length;
    const digitsBeforeCursor = rawValue.slice(0, cursorPosition).replace(/[^\d]/g, "").length;
    input.value = formattedValue;

    if (digitsBeforeCursor === 0) {
      input.setSelectionRange(0, 0);
    } else {
      let nextCursorPosition = formattedValue.length;
      let seenDigits = 0;
      for (let i = 0; i < formattedValue.length; i++) {
        if (/\d/.test(formattedValue[i])) {
          seenDigits += 1;
        }
        if (seenDigits >= digitsBeforeCursor) {
          nextCursorPosition = i + 1;
          break;
        }
      }
      input.setSelectionRange(nextCursorPosition, nextCursorPosition);
    }
  } else {
    input.value = formattedValue;
  }

  return rentPerMonth;
}

function initCalculator() {
  const rentInput = document.getElementById("rent-input") as HTMLInputElement | null;
  if (!rentInput) {
    return;
  }

  function render(rentPerMonth: number) {
    const rentPerYear = rentPerMonth * MONTHS_PER_YEAR;
    const deposit = (rentPerYear / WEEKS_PER_YEAR) * WEEKS_DEPOSIT;

    const shareContribution = deposit * DEPOSIT_CONTRIBUTION_SHARE_RATE;
    const scrayeSharePays = deposit - shareContribution;
    const serviceFee = DEPOSIT_FEE_SPREAD_RATE * rentPerYear;
    const shareSaving = deposit > 0 ? 1 - DEPOSIT_CONTRIBUTION_SHARE_RATE : 0;

    const updates: Record<string, string> = {
      "row-deposit-standard": formatPounds(deposit),
      "row-deposit-share": formatPounds(deposit),
      "row-pay-standard": formatPounds(deposit),
      "row-pay-share": formatPounds(shareContribution),
      "row-scraye-share": formatPounds(scrayeSharePays),
      "row-fee-share": formatPounds(serviceFee),
      "row-saving-share": formatPercent(shareSaving),
      "row-return-standard": formatPounds(deposit),
      "row-return-share": formatPounds(shareContribution),
    };

    for (const [id, value] of Object.entries(updates)) {
      const element = document.getElementById(id);
      if (element) {
        element.textContent = value;
      }
    }
  }

  if (!rentInput.value) {
    rentInput.value = "1000";
  }

  render(formatRentInput(rentInput, false));
  rentInput.addEventListener("input", () => {
    render(formatRentInput(rentInput, true));
  });
}

initCalculator();
